import BaseModifierBehavior, { isValueCardState } from './BaseModifierBehavior';
import CardStateHelper, { getCardsState } from '../CardStateHelper';
import { cardsHelper } from '../CardReducer';
import CardsHelper from '../../../Utility/CardsHelper';
import { ICardStateData, ValueCardData } from '../ICardState';
import { ICardModifierData } from 'Prototype/Level/Card/ICardModifierData';
import { IGameState } from 'State/Game/IGameState';

export default class RisingModifierBehavior extends BaseModifierBehavior {
    public onCardMatched(state: IGameState, matchedCardID: string) {
        let cardsState = getCardsState(state);
        if (!this.validateUpdate(cardsState)) return state;

        if (matchedCardID === this.cardID) return state;

        const value = (cardsState.cards[this.cardID] as ValueCardData).value;
        const newValue = CardsHelper.instance.draw(value + 1);

        cardsState = CardStateHelper.updateCard(cardsState, this.cardID, {
            value: newValue,
        });

        return CardStateHelper.updateGameState(state, cardsState);
    }

    public onUndoUsed(state: IGameState, prevCardState: ICardStateData, prevModifier: ICardModifierData): IGameState {
        if (!this.validateUpdate(state.levelState.cardsState)) return state;

        if (!isValueCardState(prevCardState)) return state;

        const newValue = CardsHelper.instance.draw(prevCardState.value);

        // TODO: Update updateCard to use IGameState
        const cardsState = CardStateHelper.updateCard(state.levelState.cardsState, this.cardID, {
            value: newValue,
        });

        return CardStateHelper.updateGameState(state, cardsState);
    }
}
